import { useTranslation } from 'react-i18next';

import { PLATFORM_LANGUAGES } from '../config/reference-data';

export function LanguagesPreview({ onSignUp }: { readonly onSignUp: () => void }) {
  const { t } = useTranslation();
  return (
    <main>
      <section className="nw-section">
        <div className="nw-section__head">
          <div className="nw-section__label">{t('web.languagesPreview.eyebrow')}</div>
          <h2 className="nw-section__title">{t('web.languagesPreview.title')}</h2>
          <p className="nw-section__sub">{t('web.languagesPreview.subtitle')}</p>
        </div>
        <div className="nw-lang-grid">
          {PLATFORM_LANGUAGES.map((l) => (
            <div key={l.code} className="nw-lang-card">
              <div className="nw-lang-card__flag">{l.flag}</div>
              <div className="nw-lang-card__name">{l.name}</div>
              <div className="nw-lang-card__native">{l.native}</div>
            </div>
          ))}
        </div>
      </section>
      <section className="nw-section nw-section--narrow" style={{ paddingTop: 0 }}>
        <div className="nw-cta">
          <h2 className="nw-cta__title">{t('web.languagesPreview.ctaTitle')}</h2>
          <p className="nw-cta__sub">{t('web.languagesPreview.ctaSubtitle')}</p>
          <button type="button" className="nw-btn nw-btn--primary nw-btn--xl" onClick={onSignUp}>
            {t('common.actions.startReading')}
          </button>
        </div>
      </section>
    </main>
  );
}
